import api from "./axios";

export const listJobs = (state) =>
  api.get("/api/ingest/jobs/", { params: state ? { state } : {} }).then((r) => r.data);

export const getJob = (jobId) =>
  api.get(`/api/ingest/jobs/${jobId}/`).then((r) => r.data);

export const discardJob = (jobId) =>
  api.delete(`/api/ingest/jobs/${jobId}/`).then((r) => r.data);

// Multipart-form upload (file + metadata)
export const uploadFileJob = (sourceKind, file) => {
  const fd = new FormData();
  fd.append("source_kind", sourceKind);
  fd.append("file", file);
  fd.append("source_filename", file.name);
  return api
    .post("/api/ingest/upload/", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000, // 2 min for large player-profile zips
    })
    .then((r) => r.data);
};

// Variant with progress callback. `onProgress` receives the
// percentage (0..100) as the request body streams to the server.
// 2026-06-12 — added for the /admin/ingest/players inline uploader.
export const uploadFileJobWithProgress = (sourceKind, file, onProgress) => {
  const fd = new FormData();
  fd.append("source_kind", sourceKind);
  fd.append("file", file);
  fd.append("source_filename", file.name);
  return api
    .post("/api/ingest/upload/", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 30 * 60 * 1000,
      onUploadProgress: (e) => {
        if (!onProgress) return;
        const total = e.total || e.event?.total || 0;
        const loaded = e.loaded || e.event?.loaded || 0;
        const pct = total ? Math.round((loaded / total) * 100) : null;
        onProgress({ loaded, total, percent: pct });
      },
    })
    .then((r) => r.data);
};

export const uploadTextJob = (text, filename = "pasted-text.txt") =>
  api
    .post("/api/ingest/upload/", {
      source_kind: "TEXT",
      source_text: text,
      source_filename: filename,
    })
    .then((r) => r.data);

export const extractJob = (jobId, model) =>
  api
    .post(
      `/api/ingest/jobs/${jobId}/extract/`,
      model ? { model } : {},
      { timeout: 600000 } // up to 10 min for big zips / Claude calls
    )
    .then((r) => r.data);

export const refineJob = (jobId, message) =>
  api
    .post(
      `/api/ingest/jobs/${jobId}/refine/`,
      { message },
      { timeout: 600000 }
    )
    .then((r) => r.data);

export const commitJob = (jobId) =>
  api
    .post(
      `/api/ingest/jobs/${jobId}/commit/`,
      {},
      { timeout: 300000 }
    )
    .then((r) => r.data);

export const decideCandidate = (candidateId, decision, payload = {}) =>
  api
    .post(`/api/ingest/candidates/${candidateId}/decide/`, {
      decision,
      ...payload,
    })
    .then((r) => r.data);
